export default {
  zhTW: "中文（繁體）",
  enUS: "英語",
};
